import React, { useState, useEffect, useMemo } from 'react';
import {  FlatList, TouchableOpacity, View } from 'react-native'


import BottomSheet from '../../../../../components/BottomSheet';
import SearchInput from '../../../../../components/SearchInput';
import { Ionicons } from '@expo/vector-icons';
import Text from '../../../../../components/Text';
import { useQuery } from '@tanstack/react-query';
import Icon from '../../../../../components/IcomoonIcon';
import tw from '../../../../../styles/tailwind';
import api from '../../../../../utils/api';
import IconButton from '../../../../../components/IconButton';
import useFormSubmit from '../../../../../hooks/useFormSubmit';





export default function AssignNewTagModal({ communityId, unit, onRequestClose, onTagAssigned }) {
  const [selectedTag, setSelectedTag] = useState();
  // const [isSubmitting, setIsSubmitting] = useState(false);

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onTagAssigned,
    onError: (error) => {
      console.log(error)
    },
    successToastMessage: `Tag asignado`,
    method: 'put',
    endpoint: `/communities/${communityId}/access/tags/${selectedTag?.uuid}`,
  })

  function _submitForm(){
    const data = {
      unit_id: unit.uuid,
    }

    submitForm(data)
  }

  return (
    <BottomSheet
      visible
      height={400}
      showCloseButton={true}
      onRequestClose={onRequestClose}
    >
      <View style={tw`py-6 px-5 flex-1`}>
        <Text style={tw`text-lg mb-4 text-secondary font-500`}>Asignar nuevo tag</Text>


        <TagAutocomplete
          communityId={communityId}
          onTagSelected={setSelectedTag}
        />

        {/* {
          selectedTag &&
            <Text>{JSON.stringify(selectedTag)}</Text>
        } */}
      </View>

      <IconButton
        disabled={isSubmitting || ! selectedTag}
        title={isSubmitting ? "Guardando" : "Guardar vehículo"}
        style={tw`rounded-b-0 rounded-3xl py-3`}
        onPress={_submitForm}
      />
    </BottomSheet>
  )
}




function TagAutocomplete({ communityId, onTagSelected, openHeight = 60 }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTag, setSelectedTag] = useState<Unit | null>(null);
  const [showStreetSelector, setShowStreetSelector] = useState(false);

  // const { filteredTags, groupedStreetNames } = useUnitsSearch({ communityId, searchQuery })
  const { data: tags, refetch: refetchTags } = useQuery({
    queryKey: ['community.tags.unassigned', communityId],
    queryFn: () => api.get(`/communities/${communityId}/access/tags?filter=unassigned`).then(response => response.data),
  })

  const filteredTags = useMemo(() => {
    if (!tags) return []

    if (searchQuery == "") return tags

    return tags.filter(el => {
      const regex = new RegExp(searchQuery, "i")
      const nameMatches = el.name.match(regex)
      const codeMatches = el.code.match(regex)

      return nameMatches || codeMatches
    })
  }, [searchQuery, tags])


  function selectUnit(unit: Unit) {
    setSelectedTag(unit)
    setSearchQuery("")
    onTagSelected?.(unit)
  }

  function clearSelectedTag() {
    setSelectedTag(null)
    onTagSelected?.(null)
  }




  return (
    <View style={tw`z-10`}>
      {/*  h-60 */}
      <View style={tw``}>
        <SearchInput
          onChange={setSearchQuery}
          style={{ input: `bg-gray-100 h-11 text-gray-400 ${selectedTag ? 'text-secondary font-bold' : ''}`, container: `` }}
          placeholder='Buscar tag'
          value={selectedTag ? selectedTag.name : ''}
          disabled={!!selectedTag}
        />

        {/* Icono borrar query o chevron selector calle */}
        {
          selectedTag &&
            <TouchableOpacity style={tw`absolute right-3 top-1 px-2 py-2`} onPress={clearSelectedTag}>
              <Icon name="close" size={20} color={tw.color('gray-500')} />
            </TouchableOpacity>
        }
      </View>

      {
        searchQuery &&
        <View
          style={tw.style(
            `border border-gray-300 bg-white rounded left-0 right-0 h-${openHeight}`,
            filteredTags?.length === 0 && `h-12`,
            false && `absolute top-11 `
          )}
        >
          <FlatList
            keyboardDismissMode='none'
            keyboardShouldPersistTaps="handled"
            data={filteredTags}
            renderItem={({ item: tag }) =>
              <TouchableOpacity
                style={tw`px-3 border-b border-gray-200 py-2`}
                key={tag.uuid}
                onPress={(ev) => selectUnit(tag)}
              >
                <View style={tw``}>
                  <Text style={tw`text-secondary`}>{tag.name}</Text>
                </View>
              </TouchableOpacity>
            }
            // Si pongo <Text style={...}/> como root
            // en web truena Failed to set an indexed property on 'CSSStyleDeclaration': Index property setter is not supported
            ListEmptyComponent={
              <View>
                <Text style={tw`py-3 text-gray-400 px-8`}>Sin resultados</Text>
              </View>
            }
          />
        </View>
      }

    </View>
  )
}

